/* 
-- Was previously meant to query a specific a Node and go there with an offset, but
was changed to just go to top by request from merchant

*/
class ScrollToFilters extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  handle_click(e) {
    e ? e.preventDefault() : false;
    scroll({ top: 0, behavior: "smooth" });
  }

  init() {
    this.addEventListener("click", this.handle_click.bind(this));
  }
}

customElements.define("scroll-to-filters", ScrollToFilters);